var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.02,
    height: 32.02,
    viewBox: "0 0 32.02 32.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375",
    transform: "translate(-2391 137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365",
    transform: "translate(2391 -137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M16.014,0h-.008A16,16,0,0,0,3.048,25.394l-2,5.948,6.154-1.967A16.007,16.007,0,1,0,16.014,0Z",
    transform: "translate(0 0)",
    fill: "#4fce5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M125.886,132.374a4.518,4.518,0,0,1-3.142,2.259c-.837.178-1.929.32-5.608-1.2-4.7-1.949-7.735-6.73-7.971-7.04a9.144,9.144,0,0,1-1.9-4.829,5.111,5.111,0,0,1,1.637-3.9,2.326,2.326,0,0,1,1.637-.574c.2,0,.376.01.536.018.47.02.706.048,1.017.79.386.931,1.327,3.228,1.439,3.464a.953.953,0,0,1,.068.867,2.767,2.767,0,0,1-.518.734c-.236.272-.46.48-.7.772-.216.254-.46.526-.188,1a14.211,14.211,0,0,0,2.6,3.228,11.771,11.771,0,0,0,3.754,2.315,1.012,1.012,0,0,0,1.129-.178,19.378,19.378,0,0,0,1.251-1.657.894.894,0,0,1,1.149-.348c.432.15,2.72,1.281,3.19,1.515s.78.348.895.546A3.987,3.987,0,0,1,125.886,132.374Z",
    transform: "translate(-100.556 -109.765)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.c8c7dd55c73e3ad8052c913373f55fd5.svg";
export { ForwardRef as ReactComponent };